"use strict";
export const REGIONS = {
  CANADA: "canada",
  AUSTRALIA: "australia"
};
export const getCurrentRegion = () => {
  return window.location.hostname === "scouterecruit.net" ? REGIONS.CANADA : REGIONS.AUSTRALIA;
};
